<template>
    <span class="mx-3 d-none d-sm-block">{{ $tm(separator) }}</span>
</template>
<script setup lang="ts">
import { $tm } from '@/locize';

const props = withDefaults(
    defineProps<{
        /**
         * The separator to display.
         * @default '-'
         */
        separator?: string;
    }>(),
    {
        separator: '-',
    },
);
</script>
